import { CertidaoNegativaRepository } from './certidao-negativa-repository'
import { api } from '../../plugins/api'

export * from './boleto'
export * from './status'
export * from './solicitacao'
export * from './certidao-negativa-repository'

export const certidao_negativa_repository = new CertidaoNegativaRepository(api)

